import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

/* ── Slot machine icon (embedded) ──────────────────────────────────────── */
const SLOT_ICON = "data:image/jpeg;base64,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";

const D = {
  bg:          "#2f2f2f",
  surface:     "#252323",
  surfaceAlt:  "#201f1f",
  surfaceHov:  "#202020",
  border:      "#2a2a2a",
  borderStrong:"#3a3a3a",
  borderGold:  "#bca97a",
  gold:        "#e2bf6d",
  goldDim:     "#7a5c1a",
  goldSoft:    "#1c1608",
  text:        "#ffffff",
  textMuted:   "#a0a0a0",
  textDim:     "#555555",
  red:         "#f85149",
  redBg:       "#200d0d",
};

const UI = "'Trebuchet MS', 'Gill Sans', system-ui, sans-serif";

const inputStyle = (focused) => ({
  width:        '100%',
  padding:      '11px 14px',
  background:   D.surfaceAlt,
  border:       `1px solid ${focused ? D.borderGold : D.border}`,
  borderRadius: 8,
  color:        D.text,
  fontSize:     13,
  fontFamily:   'inherit',
  outline:      'none',
  boxSizing:    'border-box',
  transition:   'border-color 0.15s',
});

const labelStyle = {
  display:       'block',
  fontSize:      10,
  fontWeight:    700,
  color:         D.textMuted,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  marginBottom:  6,
  fontFamily:    UI,
};

function Field({ label, children }) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>
      {children}
    </div>
  );
}

export default function Login({ onLogin }) {
  const [userId,       setUserId]       = useState('demo_user');
  const [casinoId,     setCasinoId]     = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [error,        setError]        = useState('');
  const [loading,      setLoading]      = useState(false);
  const [authBambi,    setAuthBambi]    = useState(false);

  const [focus, setFocus] = useState({});
  const onFocus = k => () => setFocus(p => ({ ...p, [k]: true  }));
  const onBlur  = k => () => setFocus(p => ({ ...p, [k]: false }));

  useEffect(() => {
    const check = async () => {
      const params = new URLSearchParams(window.location.search);
      const token  = params.get('token');
      const email  = params.get('email');
      if (!token) return;
      setAuthBambi(true);
      try {
        const payload = email ? { email, token } : { token };
        const { data } = await axios.post(`${API_URL}/auth/wordpress/verify`, payload, { timeout: 30000 });
        if (data.success && data.access_token) {
          onLogin(data.access_token, data.user?.email || data.user?.user_id || 'bambi_user', data.casino?.id || 'unknown');
        } else throw new Error(data.message || 'Authentication failed');
      } catch (err) {
        let msg = 'Bambi authentication failed. ';
        if (err.response?.status === 401)  msg += 'Invalid or expired token.';
        else if (err.response?.status === 404) msg += 'No casino mapping found.';
        else if (err.response?.status === 400) msg += err.response?.data?.detail || 'Invalid request.';
        else if (err.code === 'ERR_NETWORK')   msg += 'Cannot connect to backend.';
        else msg += err.response?.data?.message || err.message || 'Please try again.';
        setError(msg);
        setAuthBambi(false);
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };
    check();
  }, [onLogin]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    if (!userId.trim() || !casinoId.trim() || !clientSecret.trim()) {
      setError('Please fill in all fields'); setLoading(false); return;
    }
    try {
      const { data } = await axios.post(`${API_URL}/auth/token`, {
        user_id: userId.trim(), casino_id: casinoId.trim(), client_secret: clientSecret,
      });
      if (data.access_token) onLogin(data.access_token, userId.trim(), casinoId.trim());
    } catch (err) {
      if      (err.response?.status === 401) setError('Invalid credentials. Check your User ID and Client Secret.');
      else if (err.response?.status === 404) setError('Casino not found. Verify your Casino ID.');
      else if (err.code === 'ERR_NETWORK')   setError('Cannot connect to backend.');
      else setError(err.response?.data?.detail || 'Authentication failed. Please try again.');
    } finally { setLoading(false); }
  };

  /* ── Bambi loading screen ──────────────────────────────────────────── */
  if (authBambi) {
    return (
      <div style={{ minHeight: '100vh', background: D.bg, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
        <img src={SLOT_ICON} alt="Casino" style={{ width: 72, height: 72, objectFit: 'contain' }} />
        <p style={{ color: D.gold, fontSize: 14, fontWeight: 700, fontFamily: UI, letterSpacing: '0.05em' }}>
          Authenticating with Bambi…
        </p>
        <div style={{ display: 'flex', gap: 6 }}>
          {[0, 0.15, 0.3].map((d, i) => (
            <div key={i} style={{ width: 8, height: 8, borderRadius: '50%', background: D.gold, animation: 'bounce 0.9s infinite', animationDelay: `${d}s` }} />
          ))}
        </div>
        <style>{`@keyframes bounce{0%,80%,100%{transform:translateY(0)}40%{transform:translateY(-8px)}}`}</style>
      </div>
    );
  }

  /* ── Login page ────────────────────────────────────────────────────── */
  return (
    <div style={{ minHeight: '100vh', background: D.bg, display: 'flex', flexDirection: 'column' }}>

      {/* Top bar */}
      <div style={{ background: D.surface, borderBottom: `1px solid ${D.border}`, padding: '12px 24px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <img src={SLOT_ICON} alt="Casino" style={{ width: 28, height: 28, objectFit: 'contain' }} />
        <span style={{ fontSize: 12, fontWeight: 700, color: D.gold, letterSpacing: '0.12em', textTransform: 'uppercase', fontFamily: UI }}>
          Casino Analytics
        </span>
      </div>

      {/* Centred card */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' }}>
        <div style={{ width: '100%', maxWidth: 420 }}>

          {/* Logo block */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, marginBottom: 32 }}>
            <img
              src={SLOT_ICON}
              alt="Casino Analytics"
              style={{ width: 80, height: 80, objectFit: 'contain', filter: 'drop-shadow(0 4px 16px rgba(226,191,109,0.25))' }}
            />
            <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: D.text, fontFamily: 'Georgia, serif', letterSpacing: '0.02em' }}>
              Casino Analytics
            </h1>
            <p style={{ margin: 0, fontSize: 13, color: D.textMuted, fontFamily: UI }}>
              Sign in to access your casino insights
            </p>
          </div>

          {/* Error */}
          {error && (
            <div style={{ background: D.redBg, border: `1px solid ${D.red}44`, borderRadius: 8, padding: '10px 14px', marginBottom: 18, fontSize: 12, color: D.red, lineHeight: 1.6, fontFamily: UI }}>
              {error}
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <Field label="User ID">
              <input
                type="text"
                value={userId}
                onChange={e => setUserId(e.target.value)}
                placeholder="demo_user"
                disabled={loading}
                style={inputStyle(focus.userId)}
                onFocus={onFocus('userId')}
                onBlur={onBlur('userId')}
              />
            </Field>

            <Field label="Casino ID">
              <input
                type="text"
                value={casinoId}
                onChange={e => setCasinoId(e.target.value)}
                placeholder="Enter your casino ID"
                disabled={loading}
                style={inputStyle(focus.casinoId)}
                onFocus={onFocus('casinoId')}
                onBlur={onBlur('casinoId')}
              />
              <p style={{ fontSize: 11, color: D.textDim, marginTop: 5, fontFamily: UI }}>
                Provided by your administrator
              </p>
            </Field>

            <Field label="Client Secret">
              <input
                type="password"
                value={clientSecret}
                onChange={e => setClientSecret(e.target.value)}
                placeholder="••••••••"
                disabled={loading}
                style={inputStyle(focus.secret)}
                onFocus={onFocus('secret')}
                onBlur={onBlur('secret')}
              />
            </Field>

            <button
              type="submit"
              disabled={loading || !casinoId.trim()}
              style={{
                marginTop:    4,
                padding:      '12px',
                background:   loading || !casinoId.trim() ? D.surfaceAlt : 'linear-gradient(135deg, #e2bf6d, #7a5c1a)',
                border:       `1px solid ${loading || !casinoId.trim() ? D.border : D.borderGold}`,
                borderRadius: 8,
                color:        loading || !casinoId.trim() ? D.textDim : '#1a1000',
                fontSize:     13,
                fontWeight:   700,
                letterSpacing:'0.06em',
                cursor:       loading || !casinoId.trim() ? 'not-allowed' : 'pointer',
                fontFamily:   UI,
                transition:   'all 0.2s',
              }}
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>

      {/* Footer */}
      <div style={{ padding: '14px 24px', borderTop: `1px solid ${D.border}`, display: 'flex', justifyContent: 'center', gap: 20 }}>
        <span style={{ fontSize: 11, color: D.textDim, fontFamily: UI }}>🔒 Secure</span>
        <span style={{ fontSize: 11, color: D.textDim, fontFamily: UI }}>📊 Your data only</span>
      </div>
    </div>
  );
}